import { render, staticRenderFns } from "./FileClassificationsTab.vue?vue&type=template&id=04ddf718"
import script from "./FileClassificationsTab.vue?vue&type=script&lang=js"
export * from "./FileClassificationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports